import { StaticInterface } from '../../../helpers/static-interface';
import { Video, IVideo } from '../../../helpers/video';

export type ITpxYoutubeVideoUtils = IVideo

export interface IStaticTpxYoutubeVideoUtils {
  new(...args: any[]): ITpxYoutubeVideoUtils;
  init(scope?: HTMLElement): void;
}

/**
 * Vimeo video utilities
 * @class
 */
export default class TpxYoutubeVideoUtils extends Video implements StaticInterface<IStaticTpxYoutubeVideoUtils, typeof TpxYoutubeVideoUtils> {
  /**
   * @constructor
   * @param {HTMLElement} element The Vimeo video element
   */
  constructor(element: HTMLElement) {
    super(element);
  }

  generateIframe() {
    return `<iframe src="https://www.youtube-nocookie.com/embed/${this.id}?autoplay=1&mute=1&color=white&rel=0" allow="autoplay; encrypted-media" allowfullscreen></iframe>`;
  }

  /**
   * Creates new instances of TpxYoutubeVideoUtils for each `.a-youtube-video` element,
   * and adds the necessary event listeners to support lazy loading
   */
  static init(scope?: HTMLElement) {
    [...(scope || document).getElementsByClassName('a-youtube-video')].forEach(youtubeVideoElement => {
      const youtubeVideo = new TpxYoutubeVideoUtils(youtubeVideoElement as HTMLElement);
      youtubeVideoElement.addEventListener('click', evt => {
        evt.preventDefault();
        youtubeVideo.load();
      }, { once: true });
    });
  }
}